import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import Home from "@/pages/Home";
import Platform from "@/pages/Platform";
import UseCases from "@/pages/UseCases";
import Industries from "@/pages/Industries";
import Company from "@/pages/Company";
import PilotProgram from "@/pages/PilotProgram";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App grain min-h-screen bg-nb-base">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <main className="relative z-10 pt-0">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/platform" element={<Platform />} />
              <Route path="/use-cases" element={<UseCases />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/company" element={<Company />} />
              <Route path="/pilot-program" element={<PilotProgram />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<Privacy />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
